<ion-content class="container">
  <ion-row>
    <ion-col size="12" class="pl-15 pr-20 pb-0">
      <div class="borderbottomForTab">
        <mat-tab-group #tabGroup class="pt-10 pr-10" [selectedIndex]="selectedTypeTabIndex"
          (selectedTabChange)="tabTypeChanged($event)">
          <mat-tab label="Review Meeting">
            <ng-template mat-tab-label>
              <span style="display: contents;">
                <span class="material-icons mr-10">
                  list_alt
                </span>Review Meeting</span>
            </ng-template>
          </mat-tab>
          <mat-tab label="Daily Work Management">
            <ng-template mat-tab-label>
              <span style="display: contents;">
                <span class="material-icons mr-10">
                  insert_invitation
                </span>Daily Work Management</span>
            </ng-template>
          </mat-tab>
        </mat-tab-group>
      </div>
    </ion-col>
  </ion-row>
  <ion-row>
    <ion-col size="12" size-md="8" size-lg="9" class="pl-15 pr-15 pt-15">
      <div class="TaskManagementSubTabs" *ngIf="selectedTypeTabName == 'Review Meeting'">
        <button type="button" (click)="onClickSubTab('Dashboard')"
          [ngClass]="{'activeSubTaskTab' : selectedSubTab == 'Dashboard'}" class="borderRadiusRight tabsBtn fs-14 fs_12ForMobile"><span
            class="displayContent">
            Dashboard</span></button>
        <button type="button" (click)="onClickSubTab('My Task')" *ngIf="loggedInUserRole == 'Manager' || loggedInUserRole == 'Employee'
        || loggedInUserRole == 'HOD' || loggedInUserRole == 'MD'"
          [ngClass]="{'activeSubTaskTab' : selectedSubTab == 'My Task'}" class="tabsBtn fs-14 fs_12ForMobile"><span
            class="displayContent">
            My Task ({{myTaskCount || 0}})</span></button>
        <button type="button" (click)="onClickSubTab('Assign a Task')" *ngIf="loggedInUserRole == 'Manager' || loggedInUserRole == 'MD'
        || loggedInUserRole == 'HOD'" [ngClass]="{'activeSubTaskTab' : selectedSubTab == 'Assign a Task'}"
          class="tabsBtn fs-14 fs_12ForMobile"><span class="displayContent">
            Assign a Task ({{assignedTaskCount || 0}})</span></button>
        <button type="button" (click)="onClickSubTab('Employee Task')" *ngIf="loggedInUserRole == 'Admin' || loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Super Admin'
        || loggedInUserRole == 'PHI Admin'" [ngClass]="{'activeSubTaskTab' : selectedSubTab == 'Employee Task'}"
          class="tabsBtn fs-14 fs_12ForMobile"><span class="displayContent">
            Employee Task ({{myTaskCount || 0}})</span></button>
        <button type="button" (click)="onClickSubTab('Reports')"
          [ngClass]="{'activeSubTaskTab' : selectedSubTab == 'Reports'}" class="borderRadiusLeft tabsBtn fs-14 fs_12ForMobile"><span
            class="displayContent">
            Reports</span></button>
      </div>

      <div class="TaskManagementSubTabs" *ngIf="selectedTypeTabName == 'Daily Work Management'">
        <button type="button" (click)="onClickSubTab('Dashboard')"
          [ngClass]="{'activeSubTaskTab' : selectedSubTab == 'Dashboard'}" class="borderRadiusRight tabsBtn fs-14 fs_12ForMobile"><span
            class="displayContent">
            Dashboard</span></button>
        <button type="button" (click)="onClickSubTab('My DWM')" *ngIf="loggedInUserRole == 'Manager' || loggedInUserRole == 'Employee'
        || loggedInUserRole == 'HOD' || loggedInUserRole == 'MD'"
          [ngClass]="{'activeSubTaskTab' : selectedSubTab == 'My DWM'}" class="tabsBtn fs-14 fs_12ForMobile"><span
            class="displayContent">
            My DWM ({{myDWMCount || 0}})</span></button>
        <button type="button" (click)="onClickSubTab('Team DWM')" *ngIf="loggedInUserRole == 'Manager' || loggedInUserRole == 'MD'
        || loggedInUserRole == 'HOD'" [ngClass]="{'activeSubTaskTab' : selectedSubTab == 'Team DWM'}"
          class="tabsBtn fs-14 fs_12ForMobile"><span class="displayContent">
            Team DWM ({{teamDWMCount || 0}})</span></button>
        <button type="button" (click)="onClickSubTab('Employee DWM')" *ngIf="loggedInUserRole == 'Admin' || loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Super Admin'
        || loggedInUserRole == 'PHI Admin'" [ngClass]="{'activeSubTaskTab' : selectedSubTab == 'Employee DWM'}"
          class="tabsBtn fs-14 fs_12ForMobile"><span class="displayContent">
            Employee DWM ({{myDWMCount || 0}})</span></button>
        <button type="button" (click)="onClickSubTab('Reports')"
          [ngClass]="{'activeSubTaskTab' : selectedSubTab == 'Reports'}" class="borderRadiusLeft tabsBtn fs-14 fs_12ForMobile"><span
            class="displayContent">
            Reports</span></button>
              <!-- <button type="button" class="gotToImportDwm float-rigth fs-14 fs_12ForMobile ml-10 mr-15 isShowDesktopView"
             (click)="gotToImport()">Import</button> -->
      </div>
    </ion-col>
    <ion-col size="12" size-md="4" size-lg="3" class="pl-15 pr-20 pt-15 text-right" *ngIf="selectedSubTab == 'Employee Task' || selectedSubTab == 'My Task' || selectedSubTab == 'Assign a Task' || selectedSubTab == 'Employee DWM' || selectedSubTab == 'My DWM'">
      <ion-label class="fs-14 fs_12ForMobile font_regular pr-10 black_color">Show</ion-label>
      <mat-form-field class="w70px mat-height40 mat-input-style">
        <mat-select placeholder="Select" [(ngModel)]="selectedSizeOfTask" placeholder="Select" (selectionChange)="onSelectSizeCount()">
          <mat-option [value]="25">25</mat-option>
          <mat-option [value]="50">50</mat-option>
          <mat-option [value]="75">75</mat-option>
          <mat-option [value]="100">100</mat-option>
        </mat-select>
      </mat-form-field>
      <ion-label class="fs-14 fs_12ForMobile font_regular pl-10 black_color">entries</ion-label>
    </ion-col>
  </ion-row>
  
  <ion-row *ngIf="selectedSubTab == 'Employee Task' || selectedSubTab == 'Team DWM' || selectedSubTab == 'Employee DWM'">
    <ion-col size="12" class="pl-15 pr-15">
      <div class="phi-flex-wrap-center-gap6">
        
        <!-- ======================= For Team DWM and Employee DWM  Date Picker ====================== -->
        
        <!-- <ion-col size="12" size-md="3" > -->
          <mat-form-field class="w-100 mw-sm-250 mat-height40 mat-input-style" *ngIf="selectedSubTab == 'Team DWM' || selectedSubTab == 'Employee DWM'">
        <input readonly matInput [matDatepicker]="dailyTeamTaskFromDatePicker" placeholder="DD/MM/YYYY" [(ngModel)]="dailyTeamTaskFromDate" (dateChange)="getAllEmployeeDropdownByCompanyID();getTeamOfManager();onDWMDateChange()">
            <mat-datepicker-toggle matIconSuffix [for]="dailyTeamTaskFromDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #dailyTeamTaskFromDatePicker></mat-datepicker>
          </mat-form-field>
        <!-- </ion-col> -->
        
        <!-- ======================= For Employee Task ====================== -->
        
        <!-- <ion-col size="12" size-md="3" > -->
          <mat-form-field class="w-100 mw-sm-250 mat mat-height40 mat-input-style" *ngIf="selectedSubTab == 'Employee Task'">
            <mat-date-range-input [rangePicker]="fromToDate">
              <input readonly matStartDate dateInput placeholder="Start date" [(ngModel)]="taskFromDate">
              <input readonly matEndDate dateInput placeholder="End date" [(ngModel)]="taskToDate" (dateChange)="onDateChange()">
            </mat-date-range-input>
            <mat-datepicker-toggle matIconSuffix [for]="fromToDate"></mat-datepicker-toggle>
            <mat-date-range-picker #fromToDate></mat-date-range-picker>
          </mat-form-field>
        <!-- </ion-col> -->
        
        <!-- ======================= For Team DWM  Employee Dropdown ====================== -->
        
        <!-- <ion-col size="12" size-md="3" > -->
          <ng-select *ngIf="selectedSubTab == 'Team DWM'" class="w-100 mw-sm-250" [clearable]="false" placeholder="Select Employee" [(ngModel)]="selectedEmployeeId" (change)="onChangeSelectedEmployee()">
            <ng-option [value]="item.id" *ngFor="let item of getIndirectEmployees">{{item.name}}</ng-option>
          </ng-select>
        <!-- </ion-col> -->
        Team DWM
        <!-- <ion-col size="12" size-md="4" > -->
          <ng-multiselect-dropdown *ngIf="selectedSubTab == 'Employee Task' || selectedSubTab == 'Employee DWM'" class="w-100 mw-sm-250" [placeholder]="'Select Employee'" [settings]="dropdownSettings" [data]="getIndirectEmployees" [(ngModel)]="selectedMultiEmployeeId" (onSelect)="onSelectSingleSelectFilterEmpTasks()" (onDeSelect)="onSelectSingleSelectFilterEmpTasks()" (onSelectAll)="selectAllEmpForTask($event)" (onDeSelectAll)="onDeSelectAllEmpTask()"></ng-multiselect-dropdown>
        <!-- </ion-col> -->
        
    <button *ngIf="loggedInUserRole=='HR Admin'||loggedInUserRole=='Super Admin' " type="button" class="gotToImport float-right fs-14 fs_12ForMobile ml-10 mr-15 isShowDesktopView"
             (click)="gotToImport()">Import</button>


        <!-- <ion-col size="12" size-md="3" > -->
          <div class="center-content" *ngIf="selectedSubTab == 'Team DWM'">
            <ion-label class="fs-14 fs_12ForMobile font_regular pr-10 black_color">Show</ion-label>
            <mat-form-field class="w70px mat-height40 mat-input-style">
              <mat-select placeholder="Select" [(ngModel)]="selectedSizeOfTask" placeholder="Select" (selectionChange)="onSelectSizeCount()">
                <mat-option [value]="25">25</mat-option>
                <mat-option [value]="50">50</mat-option>
                <mat-option [value]="75">75</mat-option>
                <mat-option [value]="100">100</mat-option>
              </mat-select>
            </mat-form-field>
            <ion-label class="fs-14 fs_12ForMobile font_regular pl-10 black_color">entries</ion-label>
            <button type="button" class="gotToImport float-right fs-14 fs_12ForMobile ml-10 mr-15 isShowDesktopView"
             (click)="gotToImport()">Import</button>
          </div>
          
        </div>
      </ion-col>
    </ion-row>
    
    <ion-row *ngIf="selectedSubTab == 'Reports'">
      <ion-col size="12" size-md="9" size-lg="10" class="colmain pl-15 pr-20" >
        <div class="phi-flex-wrap-center-gap6">
          <!-- <ion-row> -->
            <!-- <ion-col size-xs="9" size-md="3" class="col1" > -->
              <mat-form-field class="w-100 mw-sm-275 mat mat-height40 mat-input-style" *ngIf="selectedTypeTabName != 'Daily Work Management'">
                <mat-date-range-input [rangePicker]="fromToDate">
                  <input readonly matStartDate dateInput placeholder="Start date" [(ngModel)]="taskFromDate">
                  <input readonly matEndDate dateInput placeholder="End date" [(ngModel)]="taskToDate" (dateChange)="onDateChange()">
                </mat-date-range-input>
                <mat-datepicker-toggle matIconSuffix [for]="fromToDate"></mat-datepicker-toggle>
                <mat-date-range-picker #fromToDate></mat-date-range-picker>
              </mat-form-field>
            <!-- </ion-col> -->
            <!-- <ion-col size-xs="6" size-md="2" class="col2" > -->
              <mat-form-field class="w-100 mw-sm-250 mat-height40 mat-input-style" *ngIf="selectedTypeTabName == 'Daily Work Management'">
                <input readonly matInput [matDatepicker]="fromToDate" placeholder="DD/MM/YYYY" [(ngModel)]="taskFromDate" (dateChange)="onFormDateChangeDWM($event)">
                <mat-datepicker-toggle matIconSuffix [for]="fromToDate"></mat-datepicker-toggle>
                <mat-datepicker #fromToDate></mat-datepicker>
              </mat-form-field>
            <!-- </ion-col> -->
            <!-- <ion-col size-xs="6" size-md="2" class="col3" > -->
              <mat-form-field class="w-100 mw-sm-250 mat-height40 mat-input-style" *ngIf="selectedTypeTabName == 'Daily Work Management'">
                <input readonly matInput [matDatepicker]="fromToDates" placeholder="DD/MM/YYYY" [(ngModel)]="taskToDate" [min]="taskFromDate" [max]="maxDate" (dateChange)="onToDateChangeDWM($event)">
                <mat-datepicker-toggle matIconSuffix [for]="fromToDates"></mat-datepicker-toggle>
                <mat-datepicker #fromToDates></mat-datepicker>
              </mat-form-field>
            <!-- </ion-col> -->
            <!-- <ion-col size-xs="6" size-md="2" class="col4" > -->
              <mat-form-field class="w-100 mw-sm-250 mat-height40 mat-input-style" *ngIf="loggedInUserRole == 'HOD' || loggedInUserRole == 'Manager'">
                <mat-select placeholder="Select" [(ngModel)]="selectedReportOf" (selectionChange)="onChangeReportOf($event)">
                  <mat-option *ngFor="let item of reportOf" [value]="item.id">{{item.name}}</mat-option>
                </mat-select>
              </mat-form-field>
            <!-- </ion-col> -->
            <!-- <ion-col size-xs="8" size-md="4" size-lg="3" class="col5" > -->
              <ng-container *ngIf="selectedReportOf == 'Team DWM' || selectedReportOf == 'Assign a Task' || loggedInUserRole == 'Admin' || loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Super Admin' || loggedInUserRole == 'PHI Admin'">
                <ng-multiselect-dropdown class="w-100 d-flex mw-sm-250" [placeholder]="'Select Employee'" [settings]="dropdownSettings" [data]="getIndirectEmployees" [(ngModel)]="selectedEmployeeIdForReport" (onSelect)="onSelectSingleSelectFilterReport()" (onDeSelect)="onSelectSingleSelectFilterReport()" (onSelectAll)="selectAllEmpForReport($event)" (onDeSelectAll)="onDeSelectAllEmpForReport()"></ng-multiselect-dropdown>
              </ng-container>
            <!-- </ion-col> -->
            <!-- <ion-col size-xs="12" size-md="2" size-lg="3" class="col6" > -->
              <div class="d-flex phi-gap-10">
                <button type="button" class="center-content add_btn fs-14 fs_12ForMobile" [style.background-color]="buttonColorName" (click)="taskManagmentReport()"><img src="././assets/icon/submitIcon.svg" class="mr-5">Submit</button>
                <div class="center-content fs-14 fs_12ForMobile">
                  <u class="cp link" (click)="onClickClearFilterReport()">Clear Filter</u>
                </div>
              </div>
            <!-- </ion-col> -->
          <!-- </ion-row> -->
        </div>
      </ion-col>
      
      <!-- <mat-form-field *ngIf="selectedTypeTabName == 'Daily Work Management'" class="w-100 mw-sm-250 mat mat-height40  mat-input-style mr-15">
        <mat-date-range-input [rangePicker]="fromToDate" [min]="minDate" [max]="maxDate">
          <input readonly matStartDate dateInput placeholder="Start date" [(ngModel)]="taskFromDate" (dateChange)="onFormDateChangeDWM($event)">
          <input readonly matEndDate dateInput placeholder="End date" [(ngModel)]="taskToDate" (dateChange)="onToDateChangeDWM($event)">
        </mat-date-range-input>
        <mat-datepicker-toggle matIconSuffix [for]="fromToDate"></mat-datepicker-toggle>
        <mat-date-range-picker #fromToDate></mat-date-range-picker>
      </mat-form-field>  -->
      
      <ion-col size="12" size-md="3" size-lg="2" class="pl-10 pt-10 pr-15">
        <div class="d-flex float-right">
          <button (click)="downloadExcel()" title="Download Excel" type="button" class="imageIcon center-content fs-14 fs_12ForMobile"><span class="ml-5 mr-5 fs-20 material-icons">download</span><span class="mr-10">Excel</span></button>
          <button (click)="downloadPdf()" title="Download PDF" type="button" class="imageIcon center-content fs-14 fs_12ForMobile ml-5"><span class="ml-5 mr-5 fs-20 material-icons">download</span><span class="mr-10">Pdf</span></button>
        </div>
      </ion-col>
    </ion-row>

    <div *ngIf="selectedTypeTabName == 'Review Meeting' && selectedSubTab=='Dashboard'" class="pl-10 pr-10 pt-5">
      <div>
        <ion-row>
          <ion-col size="12">
            <div class="phi-flex-wrap-center-gap6 justify-content-flex-end">
              <mat-form-field class="w-100 mw-sm-250 mat mat-height40 mat-input-style">
                <mat-date-range-input [rangePicker]="fromToDateDashboard">
                  <input readonly matStartDate dateInput placeholder="Start date" [(ngModel)]="taskFromDate" (dateChange)="onDateChangeDashboard()">
                  <input readonly matEndDate dateInput placeholder="End date" [(ngModel)]="taskToDate" (dateChange)="onDateChangeDashboard()">
                </mat-date-range-input>
                <mat-datepicker-toggle matIconSuffix [for]="fromToDateDashboard"></mat-datepicker-toggle>
                <mat-date-range-picker #fromToDateDashboard></mat-date-range-picker>
              </mat-form-field>
              <ng-select *ngIf="loggedInUserRole == 'Admin' || loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Super Admin' || loggedInUserRole == 'PHI Admin'" class="w-100 mw-sm-250" [clearable]="false" placeholder="Select Employee" [(ngModel)]="selectedEmpIdForDashboard" (change)="onChangeSelectedEmployee()">
                <ng-option [value]="item.id" *ngFor="let item of getIndirectEmployees">{{item.name}}</ng-option>
              </ng-select>
            </div>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col size="12" size-md="6" size-xs="12" *ngIf="loggedInUserRole != 'Employee'">
            <div class="graphs">
              <ion-row class="justify-content-center">
                <ion-col size="10" size-md="8">
                  <div class="fs-14 fs_12ForMobile font_bold">Task Assigned by Me</div>
                </ion-col>
                <ion-col size="2" size-md="4">
                  <div class="graph-icon" (click)="taskManagementDashboardGraphDownloadTaskAssignedByMe()">
                    <img src="././assets/icon/downloadIcon.svg" alt="">
                  </div>
                </ion-col>
              </ion-row>
              <ion-row>
                <ion-col size="12">
                  <mat-form-field class="w-100 mw-sm-250 mat mat-height40 mat-input-style">
                    <mat-date-range-input [rangePicker]="fromToDateTaskAssignedByMe">
                      <input readonly matStartDate dateInput placeholder="Start date"
                      [(ngModel)]="taskAssignedByMeFromDate" (dateChange)="onDateChangetaskAssignedByMe()">
                      <input readonly matEndDate dateInput placeholder="End date" [(ngModel)]="taskAssignedByMeToDate"
                      (dateChange)="onDateChangetaskAssignedByMe()">
                    </mat-date-range-input>
                    <mat-datepicker-toggle matIconSuffix [for]="fromToDateTaskAssignedByMe"></mat-datepicker-toggle>
                    <mat-date-range-picker #fromToDateTaskAssignedByMe></mat-date-range-picker>
                  </mat-form-field>
                </ion-col>
              </ion-row>
              <ion-row>
                <ion-col size="12">
                  <div id="taskAssignedByMe" style="width: 100%; height: 300px;"></div>
                </ion-col>
              </ion-row>
            </div>
          </ion-col>
          <ion-col size-sm="12" size-md="6" size-lg="6" size-xs="12">
            <div class="graphs">
              <ion-row class="justify-content-center">
                <ion-col size="10" size-md="8">
                  <div class="fs-14 fs_12ForMobile font_bold">Task Assigned to Me</div>
                </ion-col>
                <ion-col size="2" size-md="4">
                  <div class="graph-icon" (click)="onDownloadTskAssignedToMe()">
                    <img src="././assets/icon/downloadIcon.svg" alt="">
                  </div>
                </ion-col>
              </ion-row>
              <ion-row>
                <ion-col size="12">
                  <mat-form-field class="w-100 mw-sm-250 mat mat-height40 mat-input-style">
                    <mat-date-range-input [rangePicker]="fromToDateTaskAssignedToMe">
                      <input readonly matStartDate dateInput placeholder="Start date"
                      [(ngModel)]="taskAssignedToMeFromDate" (dateChange)="onDateChangetaskAssignedToMe()">
                      <input readonly matEndDate dateInput placeholder="End date" [(ngModel)]="taskAssignedToMeToDate"
                      (dateChange)="onDateChangetaskAssignedToMe()">
                    </mat-date-range-input>
                    <mat-datepicker-toggle matIconSuffix [for]="fromToDateTaskAssignedToMe"></mat-datepicker-toggle>
                    <mat-date-range-picker #fromToDateTaskAssignedToMe></mat-date-range-picker>
                  </mat-form-field>
                </ion-col>
              </ion-row>
              <ion-row>
                <ion-col size="12">
                  <div id="taskAssignedToMe1" style="width: 100%; height: 300px;"></div>
                </ion-col>
              </ion-row>
            </div>
          </ion-col>
          
          <ion-col [attr.size-lg]="isUserEmployee?6:12">
            <div class="graphs">
              <ion-row class="justify-content-center">
                <ion-col size="6" size-md="8">
                  <div *ngIf="loggedInUserRole != 'Employee'" class="fs-16 fs_14ForMobile font_bold">Employee-wise Task Status</div>
                  <div *ngIf="loggedInUserRole == 'Employee'" class="fs-16 fs_14ForMobile font_bold">Task Status</div>
                </ion-col>
                <ion-col size="6" size-md="4">
                  <ion-row class="d-flex graph-icon">
                    <ion-col size="3" (click)="setChartType('bar')">
                      <img *ngIf="empWiseTaskStatusGraphType != 'bar'" src="././assets/icon/BarGraphIcon.svg" class="cp">
                      <img *ngIf="empWiseTaskStatusGraphType == 'bar'" src="././assets/icon/BarGraphActive.svg">
                    </ion-col>
                    <ion-col size="3" (click)="setChartType('pie')">
                      <img *ngIf="empWiseTaskStatusGraphType != 'pie'" src="././assets/icon/pieChartIcon.svg" class="cp">
                      <img *ngIf="empWiseTaskStatusGraphType == 'pie'" src="././assets/icon/PieIconActive.svg">
                    </ion-col>
                    <ion-col size="3" (click)="onClickTableEmpWiseStats()">
                      <img *ngIf="!showEmpWiseStatusTble" src="././assets/icon/tableIcon.svg" class="cp">
                      <img *ngIf="showEmpWiseStatusTble" src="././assets/icon/TableIconActive.svg">
                    </ion-col>
                    <ion-col (click)="taskManagementDashboardGraphDownloadEmpWiseStats()" size="3">
                      <img src="././assets/icon/downloadIcon.svg" alt="" style="cursor: pointer;">
                    </ion-col>
                  </ion-row>
                </ion-col>
              </ion-row>
              <div class="ReaviewMeetingDashboardInputs">
                <mat-form-field class="w-100 mw-sm-250 mat mat-height40 mat-input-style mr-15 mb-10">
                  <mat-date-range-input [rangePicker]="fromToDateEmpWise">
                    <input readonly matStartDate dateInput placeholder="Start date" [(ngModel)]="employeeStatusFromDate" (dateChange)="onChangeEmpWiseTaskStatusByDateEmpId()">
                    <input readonly matEndDate dateInput placeholder="End date" [(ngModel)]="employeeStatusToDate" (dateChange)="onChangeEmpWiseTaskStatusByDateEmpId()">
                  </mat-date-range-input>
                  <mat-datepicker-toggle matIconSuffix [for]="fromToDateEmpWise"></mat-datepicker-toggle>
                  <mat-date-range-picker #fromToDateEmpWise></mat-date-range-picker>
                </mat-form-field>
                <ng-select class="w-100 mw-sm-250 mb-10" *ngIf="loggedInUserRole != 'Employee'" [clearable]="false" placeholder="Select Employee" [(ngModel)]="selectedEmpIdForEmpWiseTaskStatus" (change)="onChangeEmpWiseTaskStatusByDateEmpId()">
                  <ng-option *ngIf="loggedInUserRole == 'Manager' || loggedInUserRole == 'HOD'" [value]="loggedInUserId">My Chart</ng-option>
                  <ng-option [value]="item.id" *ngFor="let item of getIndirectEmployeesForEmpWiseTaskStatus">{{item.name}}</ng-option>
                </ng-select>
              </div>
              <div [ngClass]="{'dispNone' : showEmpWiseStatusTble}">
                <!-- <ion-row>
                  <ion-col size="6" *ngIf="isUserEmployee">
                    <div id="empTaskStatus" [ngStyle]="{ 'width': '100%' }" class="empTaskStatussm"></div>
                  </ion-col>
                  
                  <ion-col size="12" *ngIf="!isUserEmployee">
                    <div id="empTaskStatus" [ngStyle]="{ 'width': '100%' }" class="empTaskStatuslg"></div>
                  </ion-col>
                </ion-row> -->
                <div id="empTaskStatus" style="width: 100%;" [ngClass]="{ 'empTaskStatussm' : isUserEmployee, 'empTaskStatuslg' : !isUserEmployee }"></div>
                
              </div>
              <div [ngClass]="{'dispNone' : !showEmpWiseStatusTble}" class=" mt-15" id="empTaskStatusTable">
                <ion-row>
                  <ion-col size="12" class="table-container">
                    <table>
                      <thead>
                        <tr>
                          <th *ngFor="let item of getEmployeeWiseTaskStatusDataForBar">
                            <div class="font_regular verticle-center justify-content-space-between icon-style">
                              {{item?.name}}</div>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td *ngFor="let item of getEmployeeWiseTaskStatusDataForBar">
                              <div class="fs-14 fs_12ForMobile font_regular">{{item?.value}}</div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </ion-col>
                  </ion-row>
                </div>
              </div>
            </ion-col>
            
            <ion-col size-sm="12" size-md="6" size-lg="6" size-xs="12">
              <div class="graphs">
                <ion-row class="mb-15">
                  <ion-col size="10">
                    <div class="fs-16 fs_14ForMobile font_bold" *ngIf="loggedInUserRole != 'Employee'">Employee wise tasks</div>
                    <div class="fs-16 fs_14ForMobile font_bold" *ngIf="loggedInUserRole == 'Employee'">My tasks</div>
                  </ion-col>
                  <ion-col size="2" class="ion-text-end">
                    <img src="././assets/icon/downloadIcon.svg" class="cp" (click)="taskManagementDashboardGraphDownloadEmpWuiseTask()">
                  </ion-col>
                </ion-row>
                
                <div class="ReaviewMeetingDashboardInputs">
                  <mat-form-field class="w-100 mw-sm-250 mat mat-height40  mat-input-style mr-15 mb-10">
                    <mat-date-range-input [rangePicker]="fromToDateEmpWiseTask">
                      <input readonly matStartDate dateInput placeholder="Start date" [(ngModel)]="employeeTaskFromDate" (dateChange)="employeeWiseTasksEmpList()">
                      <input readonly matEndDate dateInput placeholder="End date" [(ngModel)]="employeeTaskToDate" (dateChange)="employeeWiseTasksEmpList()">
                    </mat-date-range-input>
                    <mat-datepicker-toggle matIconSuffix [for]="fromToDateEmpWiseTask"></mat-datepicker-toggle>
                    <mat-date-range-picker #fromToDateEmpWiseTask></mat-date-range-picker>
                  </mat-form-field>
                  <ng-select class="w-100 mw-sm-250 mb-10" *ngIf="loggedInUserRole != 'Employee'" [clearable]="false" placeholder="Select Employee" [(ngModel)]="selectedEmpIdForEmpWiseTask" (change)="onChangeEmpWiseTaskByDateEmpId()">
                    <ng-option *ngIf="loggedInUserRole == 'Manager' || loggedInUserRole == 'HOD'" [value]="loggedInUserId">My Chart</ng-option>
                    <ng-option [value]="item.id" *ngFor="let item of getIndirectEmployeesForEmployeeWiseTasks">{{item.name}}</ng-option>
                  </ng-select>
                </div>
                
                <div class="table-container mt-15">
                  <table class="hover mb-15" id="employeeWiseTasksTable">
                    <thead>
                      <th>
                        <div class="font_regular verticle-center justify-content-space-between icon-style">
                          Actionable
                          <div class="d-flex flex-column ml-10">
                            <i class="material-icons materialIconsHeight cp"
                            (click)="onSortAsseEmpWiseTask('actionable')">arrow_drop_up</i>
                            <i class="material-icons materialIconsHeight cp"
                            (click)="onSortDeseEmpWiseTask('actionable')">arrow_drop_down</i>
                          </div>
                        </div>
                      </th>
                      <th>
                        <div class="verticle-center justify-content-space-between icon-style">
                          Status
                          <div class="d-flex flex-column ml-10">
                            <i class="material-icons materialIconsHeight cp"
                            (click)="onSortAsseEmpWiseTask('status')">arrow_drop_up</i>
                            <i class="material-icons materialIconsHeight cp"
                            (click)="onSortDeseEmpWiseTask('status')">arrow_drop_down</i>
                          </div>
                        </div>
                      </th>
                      <th>
                        <div class="verticle-center justify-content-space-between icon-style">
                          % of Task Comp.
                          <div class="d-flex flex-column ml-10">
                            <i class="material-icons materialIconsHeight cp"
                            (click)="onSortAsseEmpWiseTask('percentageOfTaskCompletion')">arrow_drop_up</i>
                            <i class="material-icons materialIconsHeight cp"
                            (click)="onSortDeseEmpWiseTask('percentageOfTaskCompletion')">arrow_drop_down</i>
                          </div>
                        </div>
                      </th>
                    </thead>
                    <tbody>
                      <tr *ngFor="let item of employeeWiseTaskStatusData">
                        <td><textarea class="textarea" readonly>{{item?.actionable}}</textarea></td>
                        <td>
                          <button class="statusBtn"
                          [ngClass]="{'NotStarted': item?.status == 'Not Started','Completed':item?.status== 'Completed' ,'PartiallyCompleted': item?.status== 'Partially Completed','IncompleteAndEXPD': item?.status== 'Incomplete & EXPD' } ">
                          {{item?.status}}
                        </button>
                      </td>
                      <td>{{item?.percentageOfTaskCompletion}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </ion-col>
          
          <ion-col size-sm="12" size-md="6" size-lg="6" size-xs="12">
            <div class="graphs">
              <ion-row class="mb-15">
                <ion-col size="10" >
                  <div *ngIf="loggedInUserRole != 'Employee'" class="fs-16 fs_14ForMobile font_bold">Employee wise tasks with Extensions
                  </div>
                  <div *ngIf="loggedInUserRole == 'Employee'" class="fs-16 fs_14ForMobile font_bold">Tasks with Extensions</div>
                </ion-col>
                <ion-col size="2" class="ion-text-end">
                  <img src="././assets/icon/downloadIcon.svg" class="cp" (click)="taskManagementDashboardGraphDownloadEmpTaskWithExtention()">
                </ion-col>
              </ion-row>
              
              <div class="ReaviewMeetingDashboardInputs">
                <mat-form-field class="w-100 mw-sm-250 mat mat-height40  mat-input-style mr-15 mb-10">
                  <mat-date-range-input [rangePicker]="fromToDateEmpWiseTaskWithExt">
                    <input readonly matStartDate dateInput placeholder="Start date" [(ngModel)]="employeeExtentionFromDate" (dateChange)="employeeWiseTaskWithExtensionEmpList()">
                    <input readonly matEndDate dateInput placeholder="End date" [(ngModel)]="employeeExtentionToDate" (dateChange)="employeeWiseTaskWithExtensionEmpList()">
                  </mat-date-range-input>
                  <mat-datepicker-toggle matIconSuffix [for]="fromToDateEmpWiseTaskWithExt"></mat-datepicker-toggle>
                  <mat-date-range-picker #fromToDateEmpWiseTaskWithExt></mat-date-range-picker>
                </mat-form-field>
                <ng-select class="w-100 mw-sm-250 mb-10" *ngIf="loggedInUserRole != 'Employee'" [clearable]="false" placeholder="Select Employee" [(ngModel)]="selectedEmpIdForEmpWiseTaskWithExtention" (change)="onChangeEmpWiseTaskWithExtentionDateById()">
                  <ng-option *ngIf="loggedInUserRole == 'Manager' || loggedInUserRole == 'HOD'" [value]="loggedInUserId">My Chart</ng-option>
                  <ng-option [value]="item.id" *ngFor="let item of getIndirectEmployeesForEmployeeWiseTaskWithExtension">{{item.name}}</ng-option>
                </ng-select>
              </div>
              <div class="table-container mt-15" id="tasksWithExtensionsTable">
                <table class="hover mb-15">
                  <thead>
                    <th>
                      <div class="font_regular verticle-center justify-content-space-between icon-style">
                        Actionable
                        <div class="d-flex flex-column ml-10">
                          <i (click)="onSortAsseEmpTaskExt('actionable')"
                          class="material-icons materialIconsHeight cp">arrow_drop_up</i>
                          <i (click)="onSortDeseEmpTaskExt('actionable')"
                          class="material-icons materialIconsHeight cp">arrow_drop_down</i>
                        </div>
                      </div>
                    </th>
                    <th>
                      <div class="verticle-center justify-content-space-between icon-style">
                        Status
                        <div class="d-flex flex-column ml-10">
                          <i (click)="onSortAsseEmpTaskExt('taskStatus')"
                          class="material-icons materialIconsHeight cp">arrow_drop_up</i>
                          <i (click)="onSortDeseEmpTaskExt('taskStatus')"
                          class="material-icons materialIconsHeight cp">arrow_drop_down</i>
                        </div>
                      </div>
                    </th>
                    <th>
                      <div class="verticle-center justify-content-space-between icon-style">
                        No. of Extension
                        <div class="d-flex flex-column ml-10">
                          <i (click)="onSortAsseEmpTaskExt('noOfExtensions')"
                          class="material-icons materialIconsHeight cp">arrow_drop_up</i>
                          <i (click)="onSortDeseEmpTaskExt('noOfExtensions')"
                          class="material-icons materialIconsHeight cp">arrow_drop_down</i>
                        </div>
                      </div>
                    </th>
                  </thead>
                  <tbody>
                    <tr *ngFor="let item of employeeExtentionWiseTasksData">
                      <td><textarea class="textarea" readonly>{{item?.actionable}}</textarea></td>
                      <td>
                        <button class="statusBtn"
                        [ngClass]="{'NotStarted': item?.taskStatus == 'Not Started','Completed':item?.taskStatus== 'Completed' ,'PartiallyCompleted': item?.taskStatus== 'Partially Completed','IncompleteAndEXPD': item?.taskStatus== 'Incomplete & EXPD' } ">
                        {{item?.taskStatus}}
                      </button>
                    </td>
                    <td>{{item.noOfExtensions}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </ion-col>
        
        <ion-col size-sm="12" size-md="6" size-lg="6" size-xs="12">
          <div class="graphs">
            <ion-row class="mb-15">
              <ion-col size="10">
                <div class="fs-16 fs_14ForMobile font_bold">My Coming Week Task</div>
              </ion-col>
              <ion-col size="2" class="ion-text-end">
                <img src="././assets/icon/downloadIcon.svg" class="cp" (click)="taskManagementDashboardGraphDownloadMyComingWeekTask()">
              </ion-col>
            </ion-row>
            
            <div class="d-flex">
              <mat-form-field class="w-100 mw-sm-250 mat mat-height40  mat-input-style mr-15">
                <mat-date-range-input [rangePicker]="fromToDateComingWeekTask">
                  <input readonly matStartDate dateInput placeholder="Start date" [(ngModel)]="myComingWeekTaskFromDate" (dateChange)="onDateChangeMyComingWeekTask()">
                  <input readonly matEndDate dateInput placeholder="End date" [(ngModel)]="myComingWeekTaskToDate" (dateChange)="onDateChangeMyComingWeekTask()">
                </mat-date-range-input>
                <mat-datepicker-toggle matIconSuffix [for]="fromToDateComingWeekTask"></mat-datepicker-toggle>
                <mat-date-range-picker #fromToDateComingWeekTask></mat-date-range-picker>
              </mat-form-field>
            </div>
            <div class="table-container mt-15">
              <table class="hover mb-15" id="myComingWeekTaskTable">
                <thead>
                  <th>
                    <div class="font_regular verticle-center justify-content-space-between icon-style">
                      Actionable
                      <div class="d-flex flex-column ml-10">
                        <i class="material-icons materialIconsHeight cp"
                        (click)="onSortAsccomingWeekTasks('actionable')">arrow_drop_up</i>
                        <i class="material-icons materialIconsHeight cp"
                        (click)="onSortDesecomingWeekTasks('actionable')">arrow_drop_down</i>
                      </div>
                    </div>
                  </th>
                  <th>
                    <div class="verticle-center justify-content-space-between icon-style">
                      Assigned By
                      <div class="d-flex flex-column ml-10">
                        <i class="material-icons materialIconsHeight cp"
                        (click)="onSortAsccomingWeekTasks('firstName')">arrow_drop_up</i>
                        <i class="material-icons materialIconsHeight cp"
                        (click)="onSortDesecomingWeekTasks('firstName')">arrow_drop_down</i>
                      </div>
                    </div>
                  </th>
                  <th>
                    <div class="verticle-center justify-content-space-between icon-style">
                      Start Date
                      <div class="d-flex flex-column ml-10">
                        <i class="material-icons materialIconsHeight cp"
                        (click)="onSortAsccomingWeekTasks('startDate')">arrow_drop_up</i>
                        <i class="material-icons materialIconsHeight cp"
                        (click)="onSortDesecomingWeekTasks('startDate')">arrow_drop_down</i>
                      </div>
                    </div>
                  </th>
                  <th>
                    <div class="verticle-center justify-content-space-between icon-style">
                      End Date
                      <div class="d-flex flex-column ml-10">
                        <i class="material-icons materialIconsHeight cp"
                        (click)="onSortAsccomingWeekTasks('endDate')">arrow_drop_up</i>
                        <i class="material-icons materialIconsHeight cp"
                        (click)="onSortDesecomingWeekTasks('endDate')">arrow_drop_down</i>
                      </div>
                    </div>
                  </th>
                </thead>
                <tbody>
                  <tr *ngFor="let item of getComingWeekwiseData">
                    <td><textarea class="textarea" readonly>{{item?.actionable}}</textarea></td>
                    <td>{{item?.firstName}}&nbsp;{{item?.lastName}}</td>
                    <td>{{item?.startDate | date:'dd-MM-yyyy'}}</td>
                    <td>{{item?.expiryDate | date:'dd-MM-yyyy'}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </ion-col>
        
        <ion-col size="12" size-md="6" *ngIf="loggedInUserRole != 'Employee'">
          <div class="graphs">
            <ion-row class="mb-15">
              <ion-col size="10">
                <div class="fs-16 fs_14ForMobile font_bold">Allocated Task in The Week</div>
              </ion-col>
              <ion-col size="2">
                <img src="././assets/icon/downloadIcon.svg" class="cp" (click)="taskManagementDashboardGraphDownloadAllocatedWeekTask()">
              </ion-col>
            </ion-row>
            <div class="d-flex">
              <mat-form-field class="w-100 mw-sm-250 mat mat-height40  mat-input-style mr-15">
                <mat-date-range-input [rangePicker]="fromToDateAllocatedTaskIntheWeek">
                  <input readonly matStartDate dateInput placeholder="Start date" [(ngModel)]="allocatedTaskFromDate" (dateChange)="onDateChangeAllocatedTask()">
                  <input readonly matEndDate dateInput placeholder="End date" [(ngModel)]="allocatedTaskToDate" (dateChange)="onDateChangeAllocatedTask()">
                </mat-date-range-input>
                <mat-datepicker-toggle matIconSuffix [for]="fromToDateAllocatedTaskIntheWeek"></mat-datepicker-toggle>
                <mat-date-range-picker #fromToDateAllocatedTaskIntheWeek></mat-date-range-picker>
              </mat-form-field>
            </div>
            <div class="table-container mt-15" id="allocatedTaskInTheWeekTable">
              <table class="hover mb-15">
                <thead>
                  <th>
                    <div class="font_regular verticle-center justify-content-space-between icon-style">
                      Actionable
                      <div class="d-flex flex-column ml-10">
                        <i class="material-icons materialIconsHeight cp"
                        (click)="onSortAscAllocatedTask('actionable')">arrow_drop_up</i>
                        <i class="material-icons materialIconsHeight cp"
                        (click)="onSortDeseAllocatedTask('actionable')">arrow_drop_down</i>
                      </div>
                    </div>
                  </th>
                  <th>
                    <div class="verticle-center justify-content-space-between icon-style">
                      Assigned To
                      <div class="d-flex flex-column ml-10">
                        <i class="material-icons materialIconsHeight cp"
                        (click)="onSortAscAllocatedTask('firstName')">arrow_drop_up</i>
                        <i class="material-icons materialIconsHeight cp"
                        (click)="onSortDeseAllocatedTask('firstName')">arrow_drop_down</i>
                      </div>
                    </div>
                  </th>
                  <th>
                    <div class="verticle-center justify-content-space-between icon-style">
                      Start Date
                      <div class="d-flex flex-column ml-10">
                        <i class="material-icons materialIconsHeight cp"
                        (click)="onSortAscAllocatedTask('startDate')">arrow_drop_up</i>
                        <i class="material-icons materialIconsHeight cp"
                        (click)="onSortDeseAllocatedTask('startDate')">arrow_drop_down</i>
                      </div>
                    </div>
                  </th>
                  <th>
                    <div class="verticle-center justify-content-space-between icon-style">
                      End Date
                      <div class="d-flex flex-column ml-10">
                        <i class="material-icons materialIconsHeight cp"
                        (click)="onSortAscAllocatedTask('endDate')">arrow_drop_up</i>
                        <i class="material-icons materialIconsHeight cp"
                        (click)="onSortDeseAllocatedTask('endDate')">arrow_drop_down</i>
                      </div>
                    </div>
                  </th>
                </thead>
                <tbody>
                  <tr *ngFor="let item of allocatedTasksData">
                    <td><textarea class="textarea" readonly>{{item?.actionable}}</textarea></td>
                    <td>{{item?.firstName}}&nbsp;{{item?.lastName}}</td>
                    <td>{{item?.startDate | date:'dd-MM-yyyy'}}</td>
                    <td>{{item?.expiryDate | date:'dd-MM-yyyy'}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </ion-col>
      </ion-row>
    </div>
  </div>
  
  <div *ngIf="selectedTypeTabName == 'Daily Work Management' && selectedSubTab=='Dashboard'" class="pl-10 pr-10 pt-5">
    <div>
      <ion-row>
        <ion-col size="12">
 
          <div class="mb-10 ReaviewMeetingDashboardInputs justify-content-flex-end">
            <mat-form-field class="w-100 mw-sm-250 mat mat-height40  mat-input-style mr-15 mb-10">
              <mat-date-range-input [rangePicker]="fromToDateDashboardDWM">
                <input readonly matStartDate dateInput placeholder="Start date" [(ngModel)]="taskFromDate" (dateChange)="onDateChangeDashboard()">
                <input readonly matEndDate dateInput placeholder="End date" [(ngModel)]="taskToDate" (dateChange)="onDateChangeDashboard()">
              </mat-date-range-input>
              <mat-datepicker-toggle matIconSuffix [for]="fromToDateDashboardDWM"></mat-datepicker-toggle>
              <mat-date-range-picker #fromToDateDashboardDWM></mat-date-range-picker>
            </mat-form-field>
  
            <ng-select *ngIf="loggedInUserRole != 'Employee'" class="w-100 mw-sm-250 mr-15 mb-10" [clearable]="false" placeholder="Select Employee" [(ngModel)]="selectedEmpIdForDashboard" (change)="onChangeSelectedEmployee()">
              <ng-option *ngIf="loggedInUserRole == 'Manager' || loggedInUserRole == 'HOD'" [value]="loggedInUserId">My Chart</ng-option>
              <ng-option [value]="item.id" *ngFor="let item of getIndirectEmployees">{{item.name}}</ng-option>
          
            </ng-select>
            <!-- <div class="d-flex">
              <span class="ml-5 mr-5 icon-download fs-20 material-icons">download</span>
            </div> -->
          </div>
        </ion-col>
      </ion-row>
      
      <ion-row>
        <ion-col size="6" size-md="3" *ngFor="let item of dashboardCounterModule">
          <ion-row class="h-100 countercardBox cp" (click)="onClickDashboardCounter(item.ModuleName,item.totalCount)">
            <ion-col size="12" size-md="2">
              <img class="counterIcon" src="{{item.moduleActiveIcon}}" [ngStyle]="{'background': item?.background ? item.background : 'red' }">
            </ion-col>
            <ion-col size="12" size-md="10">
              <div class="font_semibold fs-12 black_color">{{item.ModuleName}}</div>
              <div class="font_bold mt-10 black_color" [ngStyle]="{'color': item?.color ? item.color : 'red' }">{{item.totalCount}}</div>
            </ion-col>
          </ion-row>
        </ion-col>
      </ion-row>
      
      <ion-row>
        <ion-col size="12" size-md="6">
          <div class="graphs">
            <ion-row class="justify-content-center">
              <ion-col size="12" size-md="7">
                <div *ngIf="loggedInUserRole != 'Employee'" class="fs-16 fs_14ForMobile font_bold">Employee wise Task Status</div>
                <div *ngIf="loggedInUserRole == 'Employee'" class="fs-16 fs_14ForMobile font_bold">Task wise Status</div>
              </ion-col>
              <ion-col size="12" size-md="5">
                <div class="graph-icon" (click)="taskManagementDashboardGraphonDownloadDWMEmpWiseTaskStatus()">
                  <img src="././assets/icon/downloadIcon.svg" alt="">
                </div>
              </ion-col>
            </ion-row>
            <div class="ReaviewMeetingDashboardInputs">
              <mat-form-field class="w-100 mw-sm-250 mat mat-height40  mat-input-style mb-10">
                <mat-date-range-input [rangePicker]="fromToDateEmpWiseTaskStatusDWM">
                  <input readonly matStartDate dateInput placeholder="Start date" [(ngModel)]="dwmEmpWiseTaskStatusFormDate" (dateChange)="employeewiseTaskStatusEmpList()">
                  <input readonly matEndDate dateInput placeholder="End date" [(ngModel)]="dwmEmpWiseTaskStatusToDate" (dateChange)="employeewiseTaskStatusEmpList()">
                </mat-date-range-input>
                <mat-datepicker-toggle matIconSuffix [for]="fromToDateEmpWiseTaskStatusDWM"></mat-datepicker-toggle>
                <mat-date-range-picker #fromToDateEmpWiseTaskStatusDWM></mat-date-range-picker>
              </mat-form-field>
              <ng-select *ngIf="loggedInUserRole != 'Employee'" class="inputForMobile w-100 mw-sm-250 mb-10" [clearable]="false" placeholder="Select Employee" [(ngModel)]="selectedEmpIdForDWMEmpWiseTaskStatus" (change)="getDWMTaskActionableList()">
                <ng-option *ngIf="loggedInUserRole == 'Manager' || loggedInUserRole == 'HOD'" [value]="loggedInUserId">My Chart</ng-option>
                <ng-option [value]="item.id" *ngFor="let item of getIndirectEmployeewiseTaskStatusEmpListTaskStatus">{{item.name}}</ng-option>
              </ng-select>
            </div>
            <ion-row class="mt-10 p-0">
              <ion-col size-xs="6" size-sm="6" size-md="6" size-lg="6" size-xl="6" class="p-0">
                <ng-select class="w-100 mw-sm-250" [clearable]="false" placeholder="Select Task" [(ngModel)]="selectedDWMTaskStatus" (change)="onChangeSelectedDWMEmpWiseTaskStatusByTaskStatus()">
                  <ng-option [value]="item" *ngFor="let item of dwmTaskStatusList">{{item}}</ng-option>
                </ng-select>
              </ion-col>
            </ion-row>
            <ion-row>
              <ion-col size="12">
                <div class="table-container mt-15">
                  <table class="hover mb-15" id="taskWiseStatusTable">
                    <thead>
                      <th>
                        <div class="font_regular verticle-center justify-content-space-between icon-style">Date</div>
                      </th>
                      <th>
                        <div class="verticle-center justify-content-space-between icon-style">Status</div>
                      </th>
                    </thead>
                    <tbody>
                      <tr *ngFor="let item of dwmEmpWiseTaskStatusData">
                        <td>{{item?.startDate}}</td>
                        <td>
                          <button *ngIf="item?.dwmStatus == 'Completed'" class="dwmstatusBtn Completed">Completed</button>
                          <button *ngIf="item?.dwmStatus == 'InCompleted'" class="dwmstatusBtn IncompleteAndEXPD">Incompleted</button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </ion-col>
            </ion-row>
          </div>
        </ion-col>
        <ion-col size-sm="12" size-md="6" size-lg="6" size-xs="12">
          <div class="graphs">
            <ion-row class="justify-content-center">
              <ion-col size-sm="12" size-md="7">
                <div *ngIf="loggedInUserRole != 'Employee'" class="fs-16 fs_14ForMobile font_bold">Employee-wise Task Completion Status</div>
                <div *ngIf="loggedInUserRole == 'Employee'" class="fs-16 fs_14ForMobile font_bold">Task Completion Status</div>
              </ion-col>
              <ion-col size-sm="12" size-md="5">
                <div class="graph-icon" (click)="taskManagementDashboardGraphononDownloadDWMTaskCompletionStatus()">
                  <img src="././assets/icon/downloadIcon.svg" alt="">
                </div>
              </ion-col>
            </ion-row>
            <div class="ReaviewMeetingDashboardInputs">
              <mat-form-field class="w-100 mw-sm-250 mat mat-height40 mat-input-style mb-10">
                <input matInput [matDatepicker]="picker" placeholder="date" [(ngModel)]="dwmCompletionStatusToDate" (dateChange)="employeewiseTaskCompletionStatusEmpList();">
                <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
              </mat-form-field>
              <ng-select *ngIf="loggedInUserRole != 'Employee'" [clearable]="false" class="inputForMobile w-100 mw-sm-250 mb-10" placeholder="Select Employee" [(ngModel)]="selectedEmpIdForDWMEmpCompletionStatus" (change)="onChangeEmpCompletionStatusByIdDate()">
                <ng-option *ngIf="loggedInUserRole == 'Manager' || loggedInUserRole == 'HOD'" [value]="loggedInUserId">My Chart</ng-option>
                <ng-option [value]="item.id" *ngFor="let item of getIndirectEmployeeTaskCompletionTaskStatus">{{item.name}}</ng-option>
              </ng-select>
            </div>
            <ion-row>
              <ion-col size="12">
                <div id="dwmCompletionsStatuss" style="width: 100%; height: 400px;"></div>
              </ion-col>
            </ion-row>
          </div>
        </ion-col>
      </ion-row>
    </div>
  </div>
  
  <ion-row *ngIf="selectedTypeTabName == 'Review Meeting' && selectedSubTab!='Dashboard'" class="pl-10 pr-10 pt-5">
    <ion-col size="12">
      <div class="tableCardBox mb-15">
        <ion-row>
          <ion-col size="12" size-md="9">
            <div class="ReaviewMeetingDashboardInputs">
              <button (click)="onClickDeleteRecord()" *ngIf="selectedTaskList.length>0"
                class="materialBtnIcon red fs-14 fs_12ForMobile font_semibold mr-15">
                <span class="material-icons fs-20">delete</span></button>
                <mat-form-field class="w-100 mw-sm-250 mat-height40 mat-input-style mr-5 mb-10">
                  <mat-icon matPrefix>search</mat-icon>
                  <input matInput type="search" placeholder="Search" [(ngModel)]="searchTaskString" (input)="onSearchTask(searchTaskString)">
                </mat-form-field>
                <ng-multiselect-dropdown *ngIf="selectedSubTab!='Reports'" class="w-100 mw-sm-250 mr-5 d-flex mb-10" [placeholder]="'Select Status'" [settings]="dropdownSettings" [data]="taskStatusList" [(ngModel)]="selectedTaskStatus" (onSelect)="onSelectFilterStatus()" (onDeSelect)="onSelectFilterStatus()" (onSelectAll)="selectAllStatus($event)" (onDeSelectAll)="onDeSelectAllStatus()"></ng-multiselect-dropdown>
                
                <mat-form-field *ngIf="selectedSubTab=='My Task' || selectedSubTab=='Assign a Task'" class="w-100 mw-sm-250 mat mat-height40  mat-input-style mr-15 mb-10">
                  <mat-date-range-input [rangePicker]="fromToDate">
                    <input readonly matStartDate dateInput placeholder="Start date" [(ngModel)]="taskFromDate">
                    <input readonly matEndDate dateInput placeholder="End date" [(ngModel)]="taskToDate" (dateChange)="onDateChange()">
                  </mat-date-range-input>
                  <mat-datepicker-toggle matIconSuffix [for]="fromToDate"></mat-datepicker-toggle>
                  <mat-date-range-picker #fromToDate></mat-date-range-picker>
                </mat-form-field>
                <label *ngIf="selectedSubTab=='Reports'">
                  <ion-label class="fs-14 fs_12ForMobile font_regular pr-10 black_color ">Show</ion-label>
                  <mat-form-field class="w70px mat-height40 mat-input-style mb-10">
                    <mat-select placeholder="Select" [(ngModel)]="selectedSizeOfTask" placeholder="Select" (selectionChange)="onSelectSizeCount()">
                      <mat-option [value]="25">25</mat-option>
                      <mat-option [value]="50">50</mat-option>
                      <mat-option [value]="75">75</mat-option>
                      <mat-option [value]="100">100</mat-option>
                    </mat-select>
                  </mat-form-field>
                  <ion-label class="fs-14 fs_12ForMobile font_regular pl-10 black_color">entries</ion-label>
                </label>
                
              </div>
            </ion-col>
            <ion-col size="12" size-md="3" class="center-content justify-content-flex-end">
              <button type="button" *ngIf="selectedSubTab == 'Assign a Task'" class="add_btn fs-14 fs_12ForMobile mr-15" [style.background-color]="buttonColorName" (click)="addNewTask()">+ New Task</button>
              <button *ngIf="this.selectedSubTab != 'Reports'" (click)="downloadExcel()" class="materialBtnIcon black_color fs-14 fs_12ForMobile font_semibold">
                <span class="material-icons">download</span></button>
              </ion-col>
            </ion-row>
            
            <ion-row>
              <ion-col>
                <div class="table-container">
                  <table class="hover mb-15">
                    <thead>
                      <tr>
                        <th class="mat-checkbox-style" *ngIf="selectedSubTab == 'Assign a Task'">
                          <mat-checkbox [(ngModel)]="selectAllTaskCheckbox" [checked]="selectAllTaskCheckbox" value=true (change)="selectALLTaskRecords($event)"></mat-checkbox>
                        </th>
                        <th class="fs-14 fs_12ForMobile font_bold cl-black" *ngFor="let item of taskColumnHeaderInfoData">
                          <div class="p-5 verticle-center justify-content-space-between icon-style">{{item?.label}}<span *ngIf="selectedSubTab == 'Assign a Task' && item.isMandatory" class="red-cl">&nbsp;*</span>
                            <div class="d-flex flex-column ml-10">
                              <i (click)="onSortAssending(item.sortingName)" class="material-icons materialIconsHeight cp">arrow_drop_up</i>
                              <i (click)="onSortDesending(item.sortingName)" class="material-icons materialIconsHeight cp">arrow_drop_down</i>
                            </div>
                          </div>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let item of taskList; let i = index;" [ngClass]="{'bgColorForRow' : item.id==null}">
                        <td class="mat-checkbox-style" *ngIf="selectedSubTab == 'Assign a Task'">
                          <mat-checkbox [checked]="item.checkboxCheck" [(ngModel)]="item.checkboxCheck" value="true" (change)="selectSingleTaskRecords($event,item,i)"></mat-checkbox>
                        </td>
                        <td [ngClass]="{'errorBorder': item.actionable=='' && isTaskSubmitted == true}">
                          <ng-container *ngIf="item.id!=null">
                            <textarea readonly rows="2" cols="4" class="textarea minw190" rows="4" [(ngModel)]="item.actionable"></textarea>
                          </ng-container>
                          <textarea *ngIf="item.id==null" rows="2" cols="4" class="edittextarea minw190" placeholder="Type here.." rows="4" [(ngModel)]="item.actionable" [ngModelOptions]="{standalone: true}"></textarea>
                        </td>
                        <td *ngIf="this.selectedSubTab == 'Employee Task' || this.selectedSubTab == 'My Task' || this.selectedSubTab == 'Reports'">
                          <ng-container *ngIf="i != isEditIndexTask">{{item.assignedBy}}</ng-container>
                        </td>
                        <td [ngClass]="{'errorBorder': item.employeeId==null && isTaskSubmitted == true}" *ngIf="this.selectedSubTab == 'Employee Task' || this.selectedSubTab == 'Assign a Task' || (this.selectedSubTab == 'Reports' && this.selectedReportOf == 'Assign a Task') || loggedInUserRole == 'Admin' ||  this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'Super Admin' || this.loggedInUserRole == 'PHI Admin'">
                          <ng-container *ngIf="item.id!=null">{{item.empName}}</ng-container>
                          <ng-select *ngIf="item.id==null" class="ml-5 w-100 mw-sm-250 editableField" placeholder="Select Employee" [(ngModel)]="item.employeeId" [ngModelOptions]="{standalone: true}">
                            <ng-option [value]="item.id" *ngFor="let item of getIndirectEmployees">{{item.name}}</ng-option>
                          </ng-select>
                        </td>
                        <td [ngClass]="{'errorBorder': item.startDate==null && isTaskSubmitted == true}" class="nowrap">
                          <ng-container *ngIf="item.id!=null">{{item.startDate | date:'dd-MM-yyyy'}}</ng-container>
                          <mat-form-field class="w-100 mat-height40 mat-input-style editableField" *ngIf="item.id==null">
                            <input readonly matInput [matDatepicker]="startDate" placeholder="DD/MM/YYYY" [(ngModel)]="item.startDate">
                            <mat-datepicker-toggle matIconSuffix [for]="startDate"></mat-datepicker-toggle>
                            <mat-datepicker #startDate></mat-datepicker>
                          </mat-form-field>
                        </td>
                        
                        <td [ngClass]="{'errorBorder': item.byWhen==null && isTaskSubmitted == true}" class="nowrap">
                          <ng-container *ngIf="item.id!=null">
                            {{item.byWhen | date:'dd-MM-yyyy'}}
                          </ng-container>
                          <mat-form-field class="w-100 mat-height40 mat-input-style editableField"
                          *ngIf="item.id==null && item.startDate!=null">
                          <input readonly matInput [matDatepicker]="byWhen" placeholder="DD/MM/YYYY"
                          [(ngModel)]="item.byWhen" [min]="item.startDate">
                          <mat-datepicker-toggle matIconSuffix [for]="byWhen"></mat-datepicker-toggle>
                          <mat-datepicker #byWhen></mat-datepicker>
                        </mat-form-field>
                      </td>
                      <td class="nowrap">
                        <ng-container>
                          {{item.extendDate1 | date:'dd-MM-yyyy'}}
                        </ng-container>
                        <!-- <mat-form-field class="w-100 mat-height40 mat-input-style" *ngIf="i == isEditIndexTask">
                          <input readonly matInput [matDatepicker]="extendDate1" placeholder="DD/MM/YYYY"
                          [(ngModel)]="item.extendDate1">
                          <mat-datepicker-toggle matIconSuffix [for]="extendDate1"></mat-datepicker-toggle>
                          <mat-datepicker #extendDate1></mat-datepicker>
                        </mat-form-field> -->
                      </td>
                      <td class="nowrap">
                        <ng-container>
                          {{item.extendDate2 | date:'dd-MM-yyyy'}}
                        </ng-container>
                        <!-- <mat-form-field class="w-100 mat-height40 mat-input-style" *ngIf="i == isEditIndexTask">
                          <input readonly matInput [matDatepicker]="extendDate2" placeholder="DD/MM/YYYY"
                          [(ngModel)]="item.extendDate2">
                          <mat-datepicker-toggle matIconSuffix [for]="extendDate2"></mat-datepicker-toggle>
                          <mat-datepicker #extendDate2></mat-datepicker>
                        </mat-form-field> -->
                      </td>
                      <td class="nowrap">
                        <ng-container>
                          {{item.extendDate3 | date:'dd-MM-yyyy'}}
                        </ng-container>
                        <!-- <mat-form-field class="w-100 mat-height40 mat-input-style" *ngIf="i == isEditIndexTask">
                          <input readonly matInput [matDatepicker]="extendDate3" placeholder="DD/MM/YYYY"
                          [(ngModel)]="item.extendDate3">
                          <mat-datepicker-toggle matIconSuffix [for]="extendDate3"></mat-datepicker-toggle>
                          <mat-datepicker #extendDate3></mat-datepicker>
                        </mat-form-field> -->
                      </td>
                      <td [ngClass]="{'errorBorder': item.taskStatus==null && isTaskSubmitted == true}">
                        <ng-container *ngIf="i != isEditIndexTask && item.id!=null">
                          <button class="statusBtn"
                          [ngClass]="{'NotStarted': item?.taskStatus == 'NotStarted','Completed':item?.taskStatus== 'Completed' ,'PartiallyCompleted': item?.taskStatus== 'PartiallyCompleted','IncompleteAndEXPD': item?.taskStatus== 'IncompleteAndEXPD' } ">
                          {{sharedService.transform(item.taskStatus)}}
                        </button>
                      </ng-container>
                      <!-- <ng-container *ngIf="selectedSubTab == 'Assign a Task'">
                        <button class="statusBtn"
                        [ngClass]="{'NotStarted': item?.taskStatus == 'NotStarted','Completed':item?.taskStatus== 'Completed' ,'PartiallyCompleted': item?.taskStatus== 'PartiallyCompleted','IncompleteAndEXPD': item?.taskStatus== 'IncompleteAndEXPD' } ">
                        {{sharedService.transform(item.taskStatus)}}
                      </button>
                    </ng-container> -->
                    
                    <ng-select [clearable]="false" class="w150 editableField"
                    *ngIf="i == isEditIndexTask || item.id==null" [clearable]="false" placeholder="Select Status"
                    [(ngModel)]="item.taskStatus">
                    <ng-option [value]="item.id" *ngFor="let item of taskStatusList">{{item.name}}</ng-option>
                  </ng-select>
                </td>
                
                <td>
                  <ng-container
                  *ngIf="(selectedSubTab == 'My Task' && !isAnyDateGreaterThanToday(item))|| selectedSubTab == 'Employee Task' ||
                  selectedSubTab == 'Reports' || (selectedSubTab == 'Assign a Task' && i != isEditIndexTask && item.id != null)">
                  {{item.percentageTaskCompletion}}
                </ng-container>
                <input *ngIf="selectedSubTab == 'My Task' && isAnyDateGreaterThanToday(item)"
                [(ngModel)]="item.percentageTaskCompletion" maxlength="3" type="number" class="edittextarea"
                placeholder="Type here.." (input)="validatePercentageTaskCompletion($event, i)"
                (blur)="onClickEditTask(i,'Edit')">
                <input *ngIf="item.id == null || i == isEditIndexTask" maxlength="3"
                [(ngModel)]="item.percentageTaskCompletion" type="number" class="edittextarea"
                placeholder="Type here.." (input)="validatePercentageTaskCompletion($event, i)">
              </td>
              
              <td>
                <ng-container
                *ngIf="(i != isEditIndexTask  && selectedSubTab != 'My Task') || !isAnyDateGreaterThanToday(item)">
                <textarea readonly rows="2" cols="4" class="textarea" rows="4"
                [(ngModel)]="item.employeeComment"></textarea>
              </ng-container>
              <textarea (ngModelChange)="checkLengthOfField(item.actionable)"
              *ngIf="selectedSubTab == 'My Task' && isAnyDateGreaterThanToday(item)" rows="2" cols="4"
              class="edittextarea" (blur)="onClickEditTask(i,'Edit')" placeholder="Type here.." rows="4"
              [(ngModel)]="item.employeeComment" maxlength="255"
              [ngModelOptions]="{standalone: true}"></textarea>
            </td>
            
            <td>
              <ng-container *ngIf="item.id != null && i != isEditIndexTask">
                <textarea readonly rows="2" cols="4" class="textarea" rows="4"
                [(ngModel)]="item.reportingManagerComment"></textarea>
              </ng-container>
              <textarea (ngModelChange)="checkLengthOfField(item.actionable)"
              *ngIf="item.id == null || i == isEditIndexTask" rows="2" cols="4" class="edittextarea"
              placeholder="Type here.." rows="4" [(ngModel)]="item.reportingManagerComment"
              [ngModelOptions]="{standalone: true}" maxlength="255"></textarea>
            </td>
            
            <td
            *ngIf="i != isEditIndexTask && selectedSubTab == 'Assign a Task' && isAnyDateGreaterThanToday(item)">
            <div [matMenuTriggerFor]="menu" class="d-flex">
              <div class="flex-column cp">
                <span class="material-icons">more_vert</span>
              </div>
            </div>
            <mat-menu #menu="matMenu">
              <button class="fs-14 fs_12ForMobile font_semibold" mat-menu-item>
                <div>
                  <ul class="menu-list" style="list-style: none;padding:8px">
                    <li *ngIf="item.extendDate3 == null" class="center-content mb-15"
                    (click)="onClickExtendDueDate(item)">
                    <span class="material-icons mr-10">event</span>
                    <span class="font_regular fs-14 fs_12ForMobile">Extend Due Date</span>
                  </li>
                  <li class="center-content" *ngIf="isAnyDateGreaterThanToday(item)"
                  (click)="isAnyDateGreaterThanToday(item) ? onClickEditAssignedTasks(item, i) :  null ">
                  <img src="././assets/icon/editing.png" class="editImage1 mr-10"><span
                  class="font_regular fs-14 fs_12ForMobile">Edit</span>
                </li>
              </ul>
            </div>
          </button>
        </mat-menu>
      </td>
      <td *ngIf="item.id == null" (click)="onClickDeleteRow(i)"><span
        class="material-icons fs-20 red cp">delete</span></td>
        <td *ngIf="i == isEditIndexTask && !hideDeleteButton" (click)="onClickEditTask(i,'Edit')">
          <span class="material-icons fs-20 cp"><span style="color:green"
            class="material-icons fs-20 cp">done</span> </span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="phi-flex-wrap-center-space-between-gap6 mb-5 mt-10" *ngIf="taskList.length != 0">
      <ion-label class="fs-14 fs_12ForMobile font_bold black_color">Showing {{showingCount}} to {{showingOfCount}} of {{totalTaskCount}} entries</ion-label>
      <ul class="dt_pagination">
        <li class="active fs-16 fs_14ForMobile font_regular">{{currentPageNumber}}</li>
        <span class="fs-14 fs_12ForMobile font_regular p-10">of {{totalTaskPages}}</span>
        <li class="fs-24 fs_18ForMobile cp" (click)="previousPageTask()" [ngClass]="{'disableBtn': currentPageNumber==1}">
          &lt;</li>
          <li class="fs-24 fs_18ForMobile cp" (click)="nextPageTask()"
          [ngClass]="{'disableBtn': currentPageNumber >= totalTaskPages}">
          &gt;</li>
      </ul>
  </div>
      <div class="mt-20" *ngIf="showAddNewSaveBtn && selectedSubTab == 'Assign a Task'">
        <button class="add_btn mb-10" (click)="onClickSaveNewTask(null,'Add')">Save</button>
      </div>
    </ion-col>
  </ion-row>
</div>
</ion-col>
</ion-row>



<!-- ==================== Daily Work Management (Employee DWM,My DWM,Team DWM)==================== -->
<ion-row
*ngIf="selectedTypeTabName == 'Daily Work Management' && (selectedSubTab =='Employee DWM' || selectedSubTab =='My DWM' || selectedSubTab =='Team DWM')"
class="pl-10 pr-10 pt-5">
<ion-col size="12">
  <div class="tableCardBox mb-15">
    <ion-row>
      <ion-col size="12" size-md="8">
        <div class="ReaviewMeetingDashboardInputs">
          <button (click)="onClickDailyDeleteRecord()" *ngIf="selectedTaskList.length>0"
            class="materialBtnIcon red fs-14 fs_12ForMobile font_semibold mr-15">
            <span class="material-icons fs-20">delete</span></button>
            <mat-form-field class="mat-height40 mat-input-style mr-5 w-100 mw-sm-250 mb-10">
              <mat-icon matPrefix>search</mat-icon>
              <input matInput type="search" placeholder="Search" [(ngModel)]="searchTaskString"
              (input)="onSearchTask(searchTaskString)">
            </mat-form-field>
            <ng-multiselect-dropdown *ngIf="selectedSubTab!='Reports'" class="w-100 mw-sm-250 mr-5 d-flex mb-10"
            [placeholder]="'Select Status'" [settings]="dropdownSettings" [data]="taskStatusListDWM"
            [(ngModel)]="selectedTaskStatus" (onSelect)="onSelectFilterStatus()"
            (onDeSelect)="onSelectFilterStatus()" (onSelectAll)="selectAllStatus($event)"
            (onDeSelectAll)="onDeSelectAllStatus()"></ng-multiselect-dropdown>
            
            
            <mat-form-field *ngIf="selectedSubTab=='My DWM'" class="w-100 mw-sm-250 mat-height40 mat-input-style mb-10">
              <input readonly matInput [matDatepicker]="dailyTeamTaskFromDatePicker" placeholder="DD/MM/YYYY"
              [(ngModel)]="dailyTeamTaskFromDate" (dateChange)="onDWMDateChange()">
              <mat-datepicker-toggle matIconSuffix [for]="dailyTeamTaskFromDatePicker"></mat-datepicker-toggle>
              <mat-datepicker #dailyTeamTaskFromDatePicker></mat-datepicker>
            </mat-form-field>
            
            <label *ngIf="selectedSubTab=='Reports'">
              <ion-label class="fs-14 fs_12ForMobile font_regular pr-10 black_color">Show</ion-label>
              <mat-form-field class="w70px mat-height40 mat-input-style">
                <mat-select placeholder="Select" [(ngModel)]="selectedSizeOfTask" placeholder="Select"
                (selectionChange)="onSelectSizeCount()">
                <mat-option [value]="25">25</mat-option>
                <mat-option [value]="50">50</mat-option>
                <mat-option [value]="75">75</mat-option>
                <mat-option [value]="100">100</mat-option>
              </mat-select>
            </mat-form-field>
            <ion-label class="fs-14 fs_12ForMobile font_regular pl-10 black_color">entries</ion-label>
          </label>
        </div>
      </ion-col>
      <ion-col size="12" size-md="4" class="center-content justify-content-flex-end">
        <div class="d-flex">
          
          <div *ngIf="selectedSubTab == 'Team DWM' && isCheckSelectedDateIsTodaysDate && isDaySkipped==null  && isTaskAvailableForEmployee"
          class="text_orange center-content mr-10 fs-12 font_regular p-0 cp"  (click)="onClickSkidDay()"><u>Skip
            the Day</u></div>
            
            <div *ngIf="(selectedSubTab == 'Team DWM' || selectedSubTab == 'My DWM') && isDaySkipped!=null"
            class="icon-container center-content">
            <span class="font_semibold fs-12 red-cl">The day is skipped&nbsp;</span>
            <span class="material-icons mr-10 fs-16 fs_14ForMobile icon">info</span>
            <div class="tooltip">
              <span class="fs-14 fs_12ForMobile font_regular">{{isDaySkipped}}</span>
            </div>
          </div>
          <button type="button"
          *ngIf="selectedSubTab == 'Team DWM' && isCheckSelectedDateIsTodaysDate && selectedEmployeeId!=null && isDaySkipped==null"
          class="add_btn fs-14 fs_12ForMobile mr-15" [style.background-color]="buttonColorName" (click)="addNewTask()">
          + New DWM</button>
          <button *ngIf="this.selectedSubTab != 'Reports'" (click)="downloadExcel()"
          class="materialBtnIcon black_color fs-14 fs_12ForMobile font_semibold">
          <span class="material-icons">download</span></button>
        </div>
      </ion-col>
    </ion-row>
    
    <ion-row>
      <ion-col>
        <div class="table-container">
          <table class="hover mb-15">
            <thead>
              <tr>
                <th class="mat-checkbox-style" *ngIf="selectedSubTab == 'Team DWM'">
                  <mat-checkbox [(ngModel)]="selectAllTaskCheckbox" [checked]="selectAllTaskCheckbox" value=true
                  (change)="selectALLTaskRecords($event)"></mat-checkbox>
                </th>
                <th class="fs-14 fs_12ForMobile font_bold cl-black" *ngFor="let item of dwmColumnHeaderInfoData">
                  <div class="p-5 verticle-center justify-content-space-between icon-style">
                    {{item?.label}}
                    <span *ngIf="selectedSubTab == 'Team DWM' && item.isMandatory" class="red-cl">&nbsp;*</span>
                    <div class="d-flex flex-column ml-10">
                      <i (click)="onSortAssending(item.sortingName)"
                      class="material-icons materialIconsHeight cp">arrow_drop_up</i>
                      <i (click)="onSortDesending(item.sortingName)"
                      class="material-icons materialIconsHeight cp">arrow_drop_down</i>
                    </div>
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of taskList; let i = index;" [ngClass]="{'bgColorForRow' : item.id==null}">
                <td class="mat-checkbox-style" *ngIf="selectedSubTab == 'Team DWM'">
                  <mat-checkbox [checked]="item.checkboxCheck" [(ngModel)]="item.checkboxCheck" value="true"
                  (change)="selectSingleTaskRecords($event,item,i)"></mat-checkbox>
                </td>
                <td *ngIf="selectedSubTab == 'Reports'" class="nowrap">
                  <ng-container *ngIf="i != isEditIndexTask">
                    {{item.startDate | date:'dd-MM-yyyy'}}
                  </ng-container>
                </td>
                <td [ngClass]="{'errorBorder': item.actionable=='' && isTaskSubmitted == true}">
                  <ng-container *ngIf="item.id!=null">
                    <textarea readonly rows="2" cols="4" class="textarea minw190 " rows="4"
                    [(ngModel)]="item.actionable"></textarea>
                  </ng-container>
                  <textarea (ngModelChange)="checkLengthOfField(item.actionable)" maxlength="255"
                  (blur)="actionableCheck(item.actionable)" *ngIf="item.id == null" rows="2" cols="4"
                  class="edittextarea minw190" placeholder="Type here.." rows="4" [(ngModel)]="item.actionable"
                  [ngModelOptions]="{standalone: true}"></textarea>
                </td>
                <td
                *ngIf="this.selectedSubTab == 'Employee DWM' || (this.selectedSubTab == 'Reports' && this.selectedReportOf == 'My DWM') ||
                loggedInUserRole == 'Admin' || this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'Super Admin' || this.loggedInUserRole == 'PHI Admin'">
                <ng-container>
                  {{item.assignedBy}}
                </ng-container>
              </td>
              <td
              *ngIf="this.selectedSubTab == 'Employee DWM' || (this.selectedSubTab == 'Reports' && this.selectedReportOf == 'Team DWM')
              || loggedInUserRole == 'Admin' || this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'Super Admin' || this.loggedInUserRole == 'PHI Admin'">
              <ng-container>
                {{item.empName}}
              </ng-container>
            </td>
            <td [ngClass]="{'errorBorder': item.taskStatus==null && isTaskSubmitted == true}">
              <ng-container *ngIf="isDaySkipped!=null || (selectedSubTab == 'Team DWM' && !isDWMisEdiable(item)) 
              || (selectedSubTab == 'My DWM' && !isDWMisEdiable(item)) ||
              (selectedSubTab == 'Employee DWM')">
              <span style="color: #CC0000;" *ngIf="item.taskStatus=='InCompleted'" title="Incompleted"
              class="material-icons">close</span>
              <span style="color: #068b06;" *ngIf="item.taskStatus=='Completed'" title="Completed"
              class="material-icons">check</span>
            </ng-container>
            <div class="d-flex" *ngIf="isDaySkipped==null && ((selectedSubTab == 'Team DWM' && isDWMisEdiable(item)) 
            || (selectedSubTab == 'My DWM' && isDWMisEdiable(item)) || item.id==null)">
            <span style="color: #CC0000;" title="Incomplete" class="material-icons">close</span>
            <div class="toggle-button">
              <input type="checkbox" id=toggle-{{i}} class="toggle-checkbox" [checked]="item.taskStatusFlag"
              [(ngModel)]="item.taskStatusFlag" (change)="onToggleDWMChange($event,item.index,'Edit')">
              <label for=toggle-{{i}} class="toggle-label">
                <span class="toggle-inner"></span>
                <span class="toggle-switch"></span>
              </label>
            </div>
            <span style="color: #068b06;" title="Complete" class="material-icons">check</span>
          </div>
          
          <!-- <ng-container *ngIf="i != isEditIndexTask && item.id!=null">
            <button class="statusBtn"
            [ngClass]="{'NotStarted': item?.taskStatus == 'NotStarted','Completed':item?.taskStatus== 'Completed' ,'PartiallyCompleted': item?.taskStatus== 'PartiallyCompleted','IncompleteAndEXPD': item?.taskStatus== 'IncompleteAndEXPD' } ">
            {{sharedService.transform(item.taskStatus)}}
          </button>
        </ng-container>
        <ng-select [clearable]="false"
        *ngIf="(selectedSubTab == 'Team DWM' && i == isEditIndexTask) || item.id==null"
        class="ml-5 w-100 mw-sm-250 editableField" placeholder="Select" [(ngModel)]="item.taskStatus"
        (change)="onClickEditDWM(i,'Edit')">
        <ng-option [value]="data.id" *ngFor="let data of taskStatusListDWM">{{data.name}}</ng-option>
      </ng-select> -->
    </td>
    <!-- <td>
      <ng-container
      *ngIf="(i != isEditIndexTask && selectedSubTab != 'My DWM') || !isDWMisEdiable(item)">
      {{item.percentageTaskCompletion}}
    </ng-container>
    <input *ngIf="selectedSubTab == 'My DWM' && isDWMisEdiable(item)"
    [(ngModel)]="item.percentageTaskCompletion" type="number" class="textarea"
    placeholder="Type here.." (blur)="onClickEditDWM(i,'Edit')"
    (change)="validatePercentageTaskCompletion($event, i)">
    <input *ngIf="selectedSubTab == 'Team DWM' && i == isEditIndexTask && isDWMisEdiable(item)"
    [(ngModel)]="item.percentageTaskCompletion" type="number" class="textarea"
    placeholder="Type here.." (change)="validatePercentageTaskCompletion($event, i)">
  </td> -->
  
  <td class="bgGrey">
    <ng-container
    *ngIf="isDaySkipped!=null || (i != isEditIndexTask && selectedSubTab != 'My DWM') || !isDWMisEdiable(item)">
    <textarea readonly rows="2" cols="4" class="textarea" rows="4"
    [(ngModel)]="item.employeeComment"></textarea>
  </ng-container>
  <textarea (ngModelChange)="checkLengthOfField(item.actionable)" maxlength="255"
  *ngIf="isDaySkipped==null && selectedSubTab == 'My DWM' && isDWMisEdiable(item)" rows="2"
  cols="4" class="edittextarea" (blur)="onClickEditDWM(i,'Edit')" placeholder="Type here.."
  rows="4" [(ngModel)]="item.employeeComment" [ngModelOptions]="{standalone: true}"></textarea>
</td>

<td>
  <ng-container
  *ngIf="isDaySkipped!=null || (i != isEditIndexTask && selectedSubTab != 'Team DWM') || !isDWMisEdiable(item)">
  <textarea readonly rows="2" cols="4" class="textarea" rows="4"
  [(ngModel)]="item.reportingManagerComment"></textarea>
</ng-container>
<textarea (ngModelChange)="checkLengthOfField(item.actionable)" maxlength="255"
*ngIf="isDaySkipped==null && selectedSubTab == 'Team DWM' && isDWMisEdiable(item)" rows="2"
cols="4" class="edittextarea" placeholder="Type here.."
[(ngModel)]="item.reportingManagerComment" (keyup)="checkMaxLength(item.reportingManagerComment)"   [ngModelOptions]="{standalone: true}"
(blur)="onClickEditDWM(i,'Edit')"></textarea>
</td>
<td class="fs-14 fs_12ForMobile font_regular">
  <div *ngIf="item.documentAttachment !=  null">
    <a href="{{item.documentAttachment}}" matTooltip="{{item.documentName}}"
    target="_blank">{{getFormattedString(item.documentName)}}</a>
    <img *ngIf="selectedSubTab == 'My DWM' && isDWMisEdiable(item)" src="././assets/icon/remove.png"
    class="removeIcon ml-5 cp" (click)="onRemoveUploadedFile(item,i)">
  </div>
  
  <span class="file_input_wrap uploadBtn center-content cp editableField"
  (click)="browseImage.click()"
  *ngIf="isDaySkipped==null && item.documentAttachment == null && selectedSubTab == 'My DWM' && isDWMisEdiable(item)">
  <span class="material-icons matUpload text_orange">file_upload</span>
  <input #browseImage type="file" (change)="uploadImage($event,i)" class="hide" />
  <label for="imageUpload" class="btn btn-large text_orange ">Upload file</label>
</span>
</td>


<td>
  <mat-slide-toggle class="editableField" (change)="onClickEditDWM(i,'Edit')"
  *ngIf="selectedSubTab == 'Team DWM' && isDWMisEdiable(item) && isDaySkipped==null"
  [checked]="item.fixedTask" [(ngModel)]="item.fixedTask"></mat-slide-toggle>
  <!-- <ng-container
  
  class="toggle-switch"> -->
  
  <img class="height22"
  *ngIf="item.fixedTask && (selectedSubTab != 'Team DWM' || (isDaySkipped!=null || selectedSubTab == 'Team DWM' && !isDWMisEdiable(item)))"
  src="././assets/icon/ativeToggle.png">
  <!-- <div class="toggle-circle">
    <span class="checkmark">&#10003;1</span>
  </div> -->
<!-- </ng-container> -->
<img class="height27"
*ngIf="!item.fixedTask && (selectedSubTab != 'Team DWM' || (isDaySkipped!=null || selectedSubTab == 'Team DWM' && !isDWMisEdiable(item)))"
src="././assets/icon/incativeToggle.png">
<!-- <ng-container
*ngIf="!item.fixedTask && (selectedSubTab != 'Team DWM' || (selectedSubTab == 'Team DWM' && !isDWMisEdiable(item)))"
class="toggle-switchdisable">
<div class="toggle-circledisable">
  <span class="minus-sign">-</span>
</div>
</ng-container> -->
</td>



<!--  ===================================  Frequency  ==================== -->
<!-- <td>
  <ng-select *ngIf="selectedSubTab == 'Team DWM'" class="w-100 mw-sm-250" [clearable]="false" placeholder="Select Frequency"   panelPosition="above" [disabled]="!item.fixedTask || isDaySkipped != null" [(ngModel)]="item.frequency" (change)="onChangeSelectedFrequency(i, 'Edit')">
    <ng-option [value]="freq.frequency" *ngFor="let freq  of frequency">{{formatFrequency(freq .frequency)}}</ng-option>
  </ng-select>

  <span *ngIf="selectedSubTab != 'Team DWM'">
    {{ formatFrequency(item.frequency) }}
  </span>
  
</td> -->


<td>
  <mat-form-field class="dwm-frequency-field w-100 mw-sm-150 mat-height40" style="margin-top: 10px"
    *ngIf="selectedSubTab == 'Team DWM'">
    <mat-select   class="dwm-frequency-select"
      [(ngModel)]="item.frequency"
      name="frequencySelect"
      (opened)="item.oldFrequency = item.frequency"
      (selectionChange)="confirmFrequencyChange($event, item, i)"
      [disabled]="!item.fixedTask || isDaySkipped != null">

      <mat-option *ngFor="let freq of frequency" [value]="freq.frequency">
        {{ formatFrequency(freq.frequency) }}
      </mat-option>

    </mat-select>
  </mat-form-field>

  <span *ngIf="selectedSubTab != 'Team DWM'">
    {{ formatFrequency(item.frequency) }}
  </span>
</td>

<!-- <td
*ngIf="item.id != null && i != isEditIndexTask && selectedSubTab == 'Team DWM' && isDWMisEdiable(item)">
<div [matMenuTriggerFor]="menu" class="d-flex">
  <div class="flex-column cp">
    <span class="material-icons">more_vert</span>
  </div>
</div>
<mat-menu #menu="matMenu">
  <button class="fs-14 fs_12ForMobile font_semibold" mat-menu-item>
    <div>
      <ul style="list-style: none;padding:8px">
        <li class="center-content" (click)="onClickEditAssignedTasks(item,i)"><img
          src="././assets/icon/editing.png" class="editImage1 mr-10"><span>Edit</span>
        </li>
      </ul>
    </div>
  </button>
</mat-menu>
</td> -->
<td *ngIf="item.id == null" (click)="onClickDeleteRow(i)">
  <span class="material-icons fs-20 red cp">delete</span>
</td>
<td *ngIf="i == isEditIndexTask && !hideDeleteButton" (click)="onClickEditDWM(i,'Edit')"><span
  class="material-icons fs-20 cp"><span style="color:green"
  class="material-icons fs-20 cp">done</span> </span>
</td>
</tr>
<tr *ngIf="(taskList.length>0 && (selectedSubTab == 'Team DWM' || selectedSubTab == 'My DWM'
  || selectedSubTab == 'Employee DWM'))" style="border: none;">
  <td *ngIf="selectedSubTab == 'Team DWM'" style="border: none;"></td>
  <td style="border: none;"></td>
  <td
  *ngIf="this.selectedSubTab == 'Employee DWM' || (this.selectedSubTab == 'Reports' && this.selectedReportOf == 'My DWM') ||
  loggedInUserRole == 'Admin' || this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'Super Admin' || this.loggedInUserRole == 'PHI Admin'"
  style="border: none;"></td>
  <td
  *ngIf="this.selectedSubTab == 'Employee DWM' || (this.selectedSubTab == 'Reports' && this.selectedReportOf == 'Team DWM')
  || loggedInUserRole == 'Admin' || this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'Super Admin' || this.loggedInUserRole == 'PHI Admin'"
  style="border: none;"></td>
  <td style="border: none;">
    <span class="fs-14 fs_12ForMobile font_bold">
      Total:&nbsp;{{completedTaskStatusCount}}/{{taskList.length}}</span>
    </td>
  </tr>
</tbody>
</table>
</div>

    <div class="phi-flex-wrap-center-space-between-gap6 mb-5 mt-10" *ngIf="taskList.length != 0">
    <ion-label class="fs-14 fs_12ForMobile font_bold black_color">Showing {{showingCount}} to {{showingOfCount}} of {{totalTaskCount}} entries</ion-label>
      <ul class="dt_pagination">
        <li class="active fs-16 fs_14ForMobile font_regular">{{currentPageNumber}}</li>
        <span class="fs-14 fs_12ForMobile font_regular p-10">of {{totalTaskPages}}</span>
        <li class="fs-24 fs_18ForMobile cp" (click)="previousPageTask()" [ngClass]="{'disableBtn': currentPageNumber==1}">
          &lt;</li>
          <li class="fs-24 fs_18ForMobile cp" (click)="nextPageTask()"
          [ngClass]="{'disableBtn': currentPageNumber >= totalTaskPages}">
          &gt;</li>
      </ul>
    </div>
    <div class="mt-20" *ngIf="showAddNewSaveBtn && selectedSubTab == 'Team DWM'">
      <button class="add_btn mb-10" (click)="onClickSaveNewDWM(null,'Add')">Save</button>
    </div>
  </ion-col>
</ion-row>
</div>
</ion-col>
</ion-row>
<ion-row *ngIf="selectedTypeTabName == 'Daily Work Management' && selectedSubTab =='Reports'"
class="pl-10 pr-10 pt-5">
<ion-col size-xs="12" size-sm="12" size-md="12" size-lg="12" size-xl="12">
  <div class="tableCardBox mb-15" *ngFor="let item of dWMReportTaskList; let i = index;">
    <ion-row class="mb-5">
      <ion-col size="6" size-md="4" class="displayVerticl">
        <label class="fs-14 fs_12ForMobile black_color font_bold">Employee name</label>
        <label class="fs-14 fs_12ForMobile textor font_bold">{{item.empName}}</label>
      </ion-col>
      <ion-col size="6" size-md="4" class="displayVerticl">
        <label class="fs-14 fs_12ForMobile black_color font_bold">Reporting Manager</label>
        <label class="fs-14 fs_12ForMobile textor font_bold">{{item.reportingManagerName}}</label>
      </ion-col>
      <ion-col size="6" size-md="2" class="displayVerticl">
        <label class="fs-14 fs_12ForMobile black_color font_bold">Department</label>
        <label class="fs-14 fs_12ForMobile textor font_bold">{{item.department}}</label>
      </ion-col>
      <ion-col size="6" size-md="2" class="d-flex">
        <label class="skipdaysLegend"></label><label class="fs-14 fs_12ForMobile black_color font_bold">&nbsp;Skip Days</label>
        
      </ion-col>
    </ion-row>
    <ion-row class="mb-10">
      <ion-col size="6" size-md="4" class="displayVerticl">
        <label class="fs-14 fs_12ForMobile black_color font_bold">Designation</label>
        <label class="fs-14 fs_12ForMobile textor font_bold">{{item.designation}}</label>
      </ion-col>
      <ion-col size="6" size-md="4" class="displayVerticl">
        <label class="fs-14 fs_12ForMobile black_color font_bold">Skip Days</label>
        <label class="fs-14 fs_12ForMobile textor font_bold">{{item.skipDateCount}}</label>
      </ion-col>
      <ion-col size="6" size-md="4" class="displayVerticl">
        <label class="fs-14 fs_12ForMobile black_color font_bold">Month</label>
        <label class="fs-14 fs_12ForMobile textor font_bold" *ngFor="let obj of item.month">{{obj}}</label>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col size="12">
        <div class="table-container">
          <table class="hover mb-15">
            <thead>
              <tr>
                <th class="fs-14 fs_12ForMobile font_bold cl-black">Sr. No</th>
                <th class="fs-14 fs_12ForMobile font_bold cl-black">Actionable</th>
                <th class="fs-14 fs_12ForMobile font_bold cl-black">Frequency</th>
                <th *ngFor="let day of item.dWMReportDisplayDate" class="fs-14 fs_12ForMobile font_bold cl-black"
                [ngClass]="{'skipdays' : day.skipDate != null}">{{day.date}}</th>
              </tr>
            </thead>
            <tbody>
   
              <tr *ngFor="let data of item.setListResponse; let j = index;">
                <td>{{j+1}}.</td>
                <td>
                  <textarea readonly rows="2" cols="4" class="edittextarea minw190" rows="4"
                  [(ngModel)]="data.actionable"></textarea>
                </td>
           
                <td>
                {{formatFrequency(data.frequency)}}
                </td>

                <td class="txtCenter" *ngFor="let item1 of data.assignedResponse; let k = index;">
                  
                  <div *ngIf="item1.documentAttachment!=null">
                    <a href="{{item1.documentAttachment}}" target="_blank">
                      <img class="attachment" src="././assets/icon/attachment.svg">
                    </a>
                  </div>
                  <span style="color: #CC0000;" *ngIf="item1.dwmStatus=='InCompleted' && item1.skipDate == null"
                  title="Incompleted" class="material-icons txtCenter">close</span>
                  <span style="color: #068b06;" *ngIf="item1.dwmStatus=='Completed' && item1.skipDate == null"
                  title="Completed" class="material-icons">check</span>
                  <!-- Fallback NA ONLY before task start date -->
                  <span *ngIf=" !item1.dwmStatus && !item1.skipDate &&
                  !item1.documentAttachment && (item1.startDate < todayDate)">
                  N/A
                </span>
                

                </td>
              </tr>
              <tr>

                <td></td>
                <td>Total</td>
                <td></td>
                <td class="txtCenter" *ngFor="let data of item.statusCountArray;">
                  {{data.completeCount}}/{{item.setListResponse.length}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </ion-col>
      </ion-row>
    </div>
  </ion-col>
</ion-row>

</ion-content>